import React from "react"
import Link from "gatsby-link"

const BigSlidePanel = ({ image, isActive }) => (
  <li className={`frame ${isActive ? "static centered" : ""} `}>
    <div className="bg" style={{ backgroundImage: `url(${image})` }} />
    <div className="small-title bottom-to-top">
      <div className="row">
        <div className="large-12 columns">
          <h2 />
        </div>
      </div>
    </div>
    <div className="title bottom-to-top">
      <div className="row">
        <div className="large-12 columns">
          <h2 />
        </div>
      </div>
    </div>
    <div className="buttons-wrapper bottom-to-top" id="move-me">
      <div className="row">
        <div className="large-12 columns">
          <div className="two spacing" />
          <a className="button " href="support.html">
            Learn More
          </a>
        </div>
      </div>
    </div>
  </li>
)

export default BigSlidePanel



// WEBPACK FOOTER //
// ./src/components/BigSlidePanel/index.js